import React from 'react'
import { FreeShipping } from '@usap/widgets'
import FreeShippingBadgeWmo from './FreeShippingBadgeWmo'
import useWmoEnabled from '../../../../../../hooks/useWmoEnabled'

const FreeShippingBadge = props => {
  const { data } = props
  const isWmoEnabled = useWmoEnabled()

  const isFreeShipping = data.inventory &&
    data.inventory.shipping.type.toLowerCase() === 'free'

  const isFreeShippingForMembers = data?.inventory?.membershipShippingType === 'Free'

  if (!isFreeShipping && !isFreeShippingForMembers) return null

  if (isWmoEnabled) {
    return (
      <FreeShippingBadgeWmo
        sku={data.product.sku}
        isFreeShipping={isFreeShipping}
        isFreeShippingForMembers={isFreeShippingForMembers}
      />
    )
  }
  return (
    <FreeShipping sku={data.product.sku} isFreeShipping={isFreeShipping} />
  )
}

export default FreeShippingBadge
